import { render } from "./AppGuest.vue?vue&type=template&id=ac107bee"
import script from "./AppGuest.vue?vue&type=script&lang=js"
export * from "./AppGuest.vue?vue&type=script&lang=js"
script.render = render

export default script